import Glide from '@glidejs/glide';

export default () => {
    const siteHeaderEl = document.querySelector('.site-header');
    const headerNavEl = siteHeaderEl.querySelector('.site-header__nav');

    // Toggla menyn
    $('.site-header__nav-toggle').click(() => {
        document.body.classList.toggle('stop-scrolling');
        siteHeaderEl.classList.toggle('site-header--menu-open');

        const hidden = headerNavEl.getAttribute('aria-hidden');
        headerNavEl.setAttribute('aria-hidden', hidden === 'true' ? 'false' : 'true');
    });

    // Avvikande öppettider toggle

    $(".store-open-hours button").click(function(){
        $(".store-open-hours__more").toggleClass('hidden');
        var $el = $(this);
        $el.text($el.text() == "Se avvikande öppettider " ? "Stäng": "Se avvikande öppettider");
    });

    // läs mer toggle

    $('.toggle-hidden').click(function(){
        $(this).next().slideToggle();
        $(this).hide();
        var divHeight =    $(".showing-content").parent().height();
        $(this).parent().parent().css('overflow-y', 'auto');
        $(this).parent().parent().css('max-height', divHeight);
    });

    $('.toggle-close').click(function(){
        $(this).parent().slideToggle();
        $(this).parent().prev().show();
    });

    //läs mer toggle relation block

    $('.read-more-relation').click(function(){
        $(this).parent().prev().addClass("text-container-show-full");
        $(this).hide();
    })

    $('.read-less-relation').click(function(){
        $(this).parent().removeClass("text-container-show-full");
        $(this).parent().next().children().show();
    })

    // tiny slider

    var sliders = document.querySelectorAll('.tiny-slider');

for (var i = 0; i < sliders.length; i++) {
  var glideTiny = new Glide(sliders[i], {
    type: 'carousel',
            perView: 3,
            autoplay: 4000,
            hoverpause: true,
            circular: true,
            animationDuration: 500
  });

  glideTiny.mount();
}

    // Header dockning
    const htmlEl = document.querySelector('html');
    const headerDocker = () => {
        const scroll = htmlEl.scrollTop;

        if (scroll >= 250) {
            document.body.classList.add('scrolled');
        } else {
            document.body.classList.remove('scrolled');
        }
    };
    document.addEventListener('wheel', headerDocker, { capture: false, passive: true });

    // TODO: Ersätt med Lozad?
    // Ta bort data-src när bilden är laddad.
    // document.querySelectorAll('img[data-src]').forEach((el) => {
    //     const img = el;
    //     img.setAttribute('src', img.getAttribute('data-src'));
    //     img.onload = () => img.removeAttribute('data-src');
    // });

    // google maps


    //let map, popup, Popup;

    /** Initializes the map and the custom popup. */
    
    /** disable Google Maps since static image is used instead
    function initMap() {
         const kungsgatan = { lat: 59.334140, lng: 18.058160 };
            var stylesArray = [
                {
                  featureType: 'road',
                  elementType: '',
                  stylers: [
                    {color: '#E6DDD0'}
                    // Add any stylers you need.
                  ]
                },
                {
                  featureType: 'landscape',
                  stylers: [
                    {color: '#FAF7F0'}
                    // Add any stylers you need.
                  ]
                },
                {
                    featureType: 'water',
                    stylers: [
                      {color: '#f2f2f2'}
                      // Add any stylers you need.
                    ]
                  },
                {
                    featureType: 'poi',
                    stylers: [
                        { color: '#d3c4bb' }
                    ]
                  },
                  {
                    featureType: 'poi',
                    elementType: 'labels',
                    stylers: [
                        { visibility: 'off' }
                    ]
                  },

              ]

                var locations = [
                  ['Kungsgatan 55', 59.334140, 18.058160, 1 ],
                  ['Åhlens City' , 59.332039, 18.060539],
                  ['Bak-fickan' ,59.333670, 18.058630 ],
                  ['Centralen' , 59.329600, 18.059650],
                  ['Karolinska' , 59.348200, 18.031170],
                  ['Gallerian', 58.907181, 17.953211 ],
                  ['Continental' , 59.33108473234567, 18.05936844230957]
              ];
                map = new google.maps.Map(document.getElementById("map"), {
                    center: kungsgatan,
                    zoom: 12,
                    styles: stylesArray
                });

                var marker, i;
                for(i = 0; i < locations.length; i++) {
                    marker = new google.maps.Marker({
                        position: new google.maps.LatLng(locations[i][1], locations[i][2]),
                        map: map
                    });
                }

};

initMap();
*/



// toggle switcher
var currentSlug = window.location.pathname;
var pathArray = currentSlug.split('/');
var lastSlug = pathArray[pathArray.length-2];

// if pathArray [4] = en put checkbox as checked
var homeUrlLast = homeUrl.split('/');
var currentLang = homeUrlLast[homeUrlLast.length-2];
if(currentLang == "en") {
    $('.switch input').prop('checked', true);
}

else {
    $('.switch input').prop('checked', false);
}

// when checkbox changes

$('.switch input').change(function() {

    var newPathname = "";
    if(this.checked) {
        // if checked (changing to ENG) - take page url + add en + last object in array

        var newPathname = homeUrl + "/en/" + lastSlug;

        window.location.replace(newPathname);
    } else {
        // if unchecked (changing to SWE), take url + remove "en" + add last object in slug

        //splice out en from array (position 3 no matter what)
        var sweUrl = homeUrlLast[2];


        if(lastSlug === "en" ) {
            var newPathname = "https://vetekatten.se/";
          } else {
            var newPathname = "https://" + sweUrl + "/" + lastSlug;
          }
        window.location.replace(newPathname);

    }
});



};
